export const uniqueSharedDocumentsName = '70303968d2f40b2c04bf5e7b5169d3e9';
export const uniqueSharedContractsName = 'e2effc79c76dcc440a163344f4162c11';
export const uniqueSharedTemplatesName = 'b0c885b1b1f7e39c234a0509f4686c47';
export const uniqueSharedProjectsName = '9823fdbfada5e832a8b195727b8daac1';
